/** Desk design tokens as typed values (mirrors tokens.css). */
export const palette = {
  charcoal: "#252422",
  warmWhite: "#F7F5F2",
  stone: "#DDD8D1",
  slate: "#70757D",
  mist: "#B7B2AA",
  borderLight: "#E5E0D8",
  darkElevated: "#1C1B1A",
  darkBorder: "#3A3834",
} as const;

export const semantic = {
  light: {
    background: "#F7F5F2",
    foreground: "#252422",
    card: "#FFFEFC",
    mutedForeground: "#61656D",
    border: "#E5E0D8",
    sidebar: "#EEEBE6",
    urgent: "#C2511A",
    priorityHigh: "#9C6A46",
    progress: "#3C5F86",
    success: "#3F6B47",
    overdue: "#B4471B",
    destructive: "#B42318",
  },
  dark: {
    background: "#252422",
    foreground: "#F2EFEA",
    card: "#2D2C29",
    mutedForeground: "#B7B2AA",
    border: "#3A3834",
    sidebar: "#1C1B1A",
    urgent: "#EC8A52",
    priorityHigh: "#D1A07C",
    progress: "#8DB0D6",
    success: "#8FBF96",
    overdue: "#EF9466",
    destructive: "#F2786B",
  },
} as const;

export const spacing = [4, 8, 16, 24, 32] as const;
/** `md` is the surface radius (cards, rows); `control` is buttons, inputs, and menu items. */
export const radii = { xs: 3, sm: 4, control: 6, md: 8, lg: 12 } as const;

export const fonts = {
  ui: { family: "Inter", file: "fonts/Inter-Variable.woff2", weight: [100, 900] as const },
  display: { family: "Manrope", file: "fonts/Manrope-Variable.woff2", weight: [200, 800] as const },
} as const;

export const motion = { fastMs: 120, baseMs: 180, easeOut: "cubic-bezier(0.2, 0.8, 0.2, 1)" } as const;
export * from "./icons";
